import type { FieldDependsOnDescriptor } from '../../fields/types/common';
import type { DependenciesFormValues } from '../../types/FormValues';
import { checkDependencyChanged } from './checkDependencyChanged';

export const getDependencyFlags = (
  prevDependencyValues: DependenciesFormValues,
  currentDependencyValues: DependenciesFormValues,
  sectionKey: string,
  dependsOn: FieldDependsOnDescriptor[] = []
): { preserveOnChange?: boolean; softReset?: boolean } => {
  if (!dependsOn.length) {
    return {};
  }

  for (const dependency of dependsOn) {
    const dependencyChanged = checkDependencyChanged(
      dependency,
      prevDependencyValues,
      currentDependencyValues,
      sectionKey
    );

    // Returns on first dependency that changed, allows priority ordering
    if (dependencyChanged) {
      return { preserveOnChange: dependency.preserveOnChange, softReset: dependency.softReset };
    }
  }

  return {};
};
